<template>
	<!-- .profile -->
  <div class="profile-page">
	  <div class="container">
      <div class="page-header color-1-100">
        <h1>
          <span>
            <template v-if="canEditDetails || canEditPassword">
              Edit my profile
            </template>
            <template v-else>
              My profile
            </template>
          </span>
        </h1>
        <div class="profile-actions">
          <button v-on:click.prevent="deleteMyProfile()" class="delete-profile delete-profile-custom background-1-20 color-2-100">
            <span class="delete-profile-icon color-1-100">
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                   viewBox="0 0 14.431 15.232" style="enable-background:new 0 0 14.431 15.232;" xml:space="preserve">
                <polygon id="XMLID_8_" class="st0" points="9.62,1.603 9.62,0 4.81,0 4.81,1.603 0,1.603 0,3.207 14.431,3.207 14.431,1.603 "/>
                <path id="XMLID_7_" class="st0" d="M1.603,4.008v9.621c0,0.884,0.719,1.603,1.603,1.603h8.017c0.884,0,1.603-0.72,1.603-1.603V4.008
                  H1.603z M6.414,12.026H4.81v-4.81h1.603V12.026z M9.62,12.026H8.017v-4.81H9.62V12.026z"/>
              </svg>
            </span>
            Delete my account
          </button>
        </div>
      </div>
      <div class="admin-breadcrumbs">
        <!--<router-link class="dashboard dashboard-custom background-1-20 color-2-100" to="/">
          <span class="dashboard-icon color-1-100">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 43.858 33.521" style="enable-background:new 0 0 43.858 33.521;" xml:space="preserve">
              <path id="XMLID_20_" class="st0" d="M39.108,0c-2.619,0-4.75,2.131-4.75,4.75c0,1.221,0.476,2.325,1.236,3.167l-4.496,7.472
                c-0.334-0.075-0.679-0.121-1.035-0.121c-1.41,0-2.664,0.63-3.535,1.608l-8.142-3.478c0.01-0.128,0.039-0.25,0.039-0.381
                c0-2.619-2.131-4.75-4.75-4.75s-4.75,2.131-4.75,4.75c0,1.221,0.476,2.325,1.236,3.167l-4.742,7.881
                c-0.603-0.086-1.222-0.055-1.83,0.099c-1.23,0.311-2.266,1.082-2.916,2.171c-0.65,1.09-0.837,2.367-0.526,3.597
                c0.311,1.231,1.082,2.267,2.171,2.917c0.745,0.444,1.579,0.672,2.425,0.672c0.391,0,0.784-0.048,1.172-0.146
                c2.54-0.642,4.083-3.229,3.442-5.769c-0.213-0.843-0.655-1.584-1.255-2.183l4.663-7.748c0.295,0.058,0.598,0.092,0.91,0.092
                c1.41,0,2.664-0.63,3.535-1.608l8.142,3.478c-0.01,0.128-0.039,0.25-0.039,0.381c0,2.619,2.131,4.75,4.75,4.75s4.75-2.131,4.75-4.75
                c0-1.175-0.445-2.237-1.154-3.067l4.539-7.542c0.295,0.058,0.598,0.092,0.91,0.092c2.619,0,4.75-2.131,4.75-4.75S41.727,0,39.108,0z
                "/>
            </svg>
          </span>
          Go to Dashboard
        </router-link>
        <router-link class="profile-group profile-group-custom background-1-20 color-2-100"
                     :to="{name: 'company-profile', id: user.personal.company.id }"
                     v-if="getUserRole !== 'cu' && user.personal.company">
          <span class="profile-group-icon color-1-100">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 15.75 13.782" style="enable-background:new 0 0 15.75 13.782;" xml:space="preserve">
              <circle id="XMLID_497_" class="st0" cx="10.635" cy="3.948" r="3.457"/>
              <path id="XMLID_496_" class="st0" d="M6.444,13.782c-0.571,0-1.002-0.515-0.912-1.078c0.408-2.55,2.297-4.107,5.103-4.107
                s4.695,1.558,5.103,4.107c0.09,0.564-0.341,1.078-0.912,1.078H6.444z"/>
              <circle id="XMLID_3_" class="st0" cx="3.589" cy="2.426" r="2.426"/>
              <path id="XMLID_2_" class="st0" d="M0.648,9.326c-0.401,0-0.703-0.361-0.64-0.757C0.295,6.78,1.62,5.687,3.589,5.687
                S6.883,6.78,7.17,8.569c0.063,0.395-0.24,0.757-0.64,0.757H0.648z"/>
            </svg>
          </span>
          Go to company profile
        </router-link>-->
        <!--<router-link class="all-users all-users-custom background-1-20 color-2-100"
                     :to="{name: 'email-preferences'}">
          <span class="all-users-icon color-1-100">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 32.053 34.5" style="enable-background:new 0 0 32.053 34.5;" xml:space="preserve">
              <g id="XMLID_10_">
                <path id="XMLID_20_" class="st0" d="M4.75,0C2.131,0,0,2.131,0,4.75S2.131,9.5,4.75,9.5S9.5,7.369,9.5,4.75S7.369,0,4.75,0z"/>
                <path id="XMLID_21_" class="st0" d="M15.178,6.25h15.375c0.829,0,1.5-0.671,1.5-1.5s-0.671-1.5-1.5-1.5H15.178
                  c-0.829,0-1.5,0.671-1.5,1.5S14.349,6.25,15.178,6.25z"/>
                <path id="XMLID_22_" class="st0" d="M4.75,12.375c-2.619,0-4.75,2.131-4.75,4.75s2.131,4.75,4.75,4.75s4.75-2.131,4.75-4.75
                  S7.369,12.375,4.75,12.375z"/>
                <path id="XMLID_23_" class="st0" d="M30.553,15.625H15.178c-0.829,0-1.5,0.671-1.5,1.5s0.671,1.5,1.5,1.5h15.375
                  c0.829,0,1.5-0.671,1.5-1.5S31.381,15.625,30.553,15.625z"/>
                <path id="XMLID_24_" class="st0" d="M4.75,25C2.131,25,0,27.131,0,29.75s2.131,4.75,4.75,4.75s4.75-2.131,4.75-4.75
                  S7.369,25,4.75,25z"/>
                <path id="XMLID_25_" class="st0" d="M30.553,28.25H15.178c-0.829,0-1.5,0.671-1.5,1.5s0.671,1.5,1.5,1.5h15.375
                  c0.829,0,1.5-0.671,1.5-1.5S31.381,28.25,30.553,28.25z"/>
              </g>
            </svg>
          </span>
          Go to email preferences
        </router-link>-->
      </div>
      <div class="flex-block">
        <div class="content-right-section anchors">
          <div class="sticky-anchors background-1-40-before" tabindex="-1">
            <div class="anchor-item anchor-item-custom color-1-20 details"
                 :class="[{ 'active  color-1-100': activeSection === 'userDetails' }]">
              <button @click.prevent="goToPageSection('userDetails')">
                <span class="anchor-item-icon color-1-40">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 20 18" style="enable-background:new 0 0 20 18;" xml:space="preserve">
                    <path id="XMLID_1_" class="st0" d="M18,2h-5.185C12.401,0.838,11.302,0,10,0S7.599,0.838,7.185,2H2C0.897,2,0,2.897,0,4v12
                      c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V4C20,2.897,19.103,2,18,2z M6,6c1.105,0,2,0.896,2,2s-0.895,2-2,2S4,9.104,4,8
                      S4.895,6,6,6z M3,14c0-1.841,1.159-3,3-3c1.841,0,3,1.159,3,3H3z M10,4C9.449,4,9,3.551,9,3c0-0.551,0.449-1,1-1s1,0.449,1,1
                      C11,3.551,10.551,4,10,4z M17,14h-6v-2h6V14z M17,10h-6V8h6V10z"/>
                  </svg>
                </span>
                <template v-if="canEditDetails === false">My account details</template>
                <template v-else>Edit my account details</template>
              </button>
            </div>
            <div class="anchor-item anchor-item-custom color-1-20 password" :class="[{ 'active  color-1-100': activeSection === 'userPassword' }]">
              <button @click.prevent="goToPageSection('userPassword')">
                <span class="anchor-item-icon color-1-40">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">
                    <path id="XMLID_1_" class="st0" d="M10,0C4.477,0,0,4.477,0,10s4.477,10,10,10c5.523,0,10-4.477,10-10S15.523,0,10,0z M11.378,10.65
                      L12,15H8l0.622-4.35C7.662,10.149,7,9.157,7,8c0-1.656,1.344-3,3-3c1.656,0,3,1.344,3,3C13,9.157,12.338,10.149,11.378,10.65z"/>
                  </svg>
                </span>
                <template v-if="canEditPassword === false">My account password</template>
                <template v-else>Edit my account password</template>
              </button>
            </div>
            <div class="anchor-item anchor-item-custom color-1-20 data" :class="[{ 'active  color-1-100': activeSection === 'userData' }]">
              <span class="anchor-item-icon color-1-40">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 19.99 21" style="enable-background:new 0 0 19.99 21;" xml:space="preserve">
                  <g>
                    <path class="st0" d="M11,14H9c-2.757,0-5,2.239-5,4.996V21h12v-2.004C16,16.239,13.756,14,11,14z"/>
                    <path class="st0" d="M6.343,12.523c-1.249-1.757-1.099-4.21,0.475-5.784c1.754-1.755,4.609-1.755,6.364,0
                      c1.574,1.573,1.724,4.027,0.475,5.784c0.629,0.259,1.212,0.608,1.733,1.028c1.702-2.526,1.439-5.992-0.793-8.226
                      c-2.534-2.535-6.658-2.533-9.193,0c-2.232,2.234-2.495,5.7-0.793,8.226C5.131,13.13,5.714,12.781,6.343,12.523z"/>
                    <path class="st0" d="M3.512,14.663C2.535,13.31,2,11.697,2,9.995c0-2.137,0.832-4.146,2.343-5.657
                      c3.119-3.119,8.194-3.119,11.313,0c2.809,2.81,3.08,7.2,0.83,10.324c0.445,0.563,0.803,1.194,1.06,1.878
                      c3.406-3.923,3.254-9.886-0.476-13.617c-3.898-3.897-10.243-3.897-14.142,0C1.041,4.812,0,7.325,0,9.995
                      c0,2.434,0.872,4.729,2.452,6.546C2.709,15.858,3.067,15.226,3.512,14.663z"/>
                    <circle class="st0" cx="10" cy="9.995" r="3"/>
                  </g>
                </svg>
              </span>
              <button @click.prevent="goToPageSection('userData')">My Data</button>
            </div>
          </div>
        </div>
        <div class="content-left-section">
          <div class="content-section profile-section no-margin-top"
               v-show="!needPasswordChange"
               :class="[{ 'content-section__bordered border-1-20': activeSection === 'userDetails' || canEditDetails }]"
               tabindex="-1"
               ref="userDetails">
            <section class="personal-info">
              <h3 class="content-section-title color-1-100 background-1-100-before">
                <template v-if="canEditDetails === false">My account details</template>
                <template v-else>Edit my account details</template>
              </h3>
              <button v-on:click.prevent="openEditDetails()"
                      class="edit-details edit-details-custom border-1-40 color-2-100" v-if="canEditDetails === false">
                <span class="edit-icon color-1-100">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 12.955 12.921" style="enable-background:new 0 0 12.955 12.921;" xml:space="preserve">
                    <g id="XMLID_1_">
                      <path id="XMLID_4_" class="st0" d="M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921
                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"/>
                      <path id="XMLID_5_" class="st0" d="M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316
                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0
                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"/>
                    </g>
                  </svg>
                </span>
                Edit
              </button>
              <div class="form-group form-group-half">
                <div class="form-element featured-image">
                  <div class="user-featured-image">
                    <span class="form-label color-2-63">Profile image</span>
                    <label class="form-label color-2-63 form-label--file-upload"
                           style="width: 100%;"
                           v-show="!isThumbnailFileUploaded && canEditDetails === true">
                      <div class="upload-text">+Upload image</div>
                      <input
                        type="file"
                        id="uploadThumbnail"
                        name="Image"
                        data-vv-as='"Image"'
                        value.sync="user.personal.image"
                        :disabled="canEditDetails === false"
                        v-validate.reject="veeValidateFileUploadRules"
                        @change="onThumbnailFileChange($event)"
                        class="form-control form-control--file" />
                    </label>
                    <div class="user-featured-image-icon"
                         v-show="!isThumbnailFileUploaded && canEditDetails === false">
                      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user"
                           class="svg-inline--fa fa-user fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg"
                           viewBox="0 0 448 512"><path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0
                             224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2
                             288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"></path>
                      </svg>
                    </div>
                    <div id="thumbnailFilePreview" v-if="isThumbnailFileUploaded" v-bind:style="{ backgroundImage: 'url(' + user.personal.image + ')' }" ></div>
                    <button
                      type="button"
                      v-if="isThumbnailFileUploaded && canEditDetails === true"
                      @click="removeThumbnail"
                      class="btn btn--remove-element">
                      <span class="btn__text">-Remove image</span>
                    </button>
                  </div>
                </div>
                <div class="form-element">
                  <label for="new-user-name" class="form-label color-2-63">First name</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('First name'), 'is-locked': !canEditDetails, 'is-blocked': consentStatus === 0 }]"
                         :disabled="canEditDetails === false || consentStatus === 0"
                         data-lpignore="true"
                         v-on:keyup="fieldChange"
                         v-model="user.personal.first_name"
                         id="new-user-name"
                         v-validate="'required'"
                         name="First name">
                  <span class="form-field-error" v-if="this.errors.has('First name')">{{ this.errors.first('First name') }}</span>
                </div>
                <div class="form-element">
                  <label for="new-user-surname" class="form-label color-2-63">Last name</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Last name'), 'is-locked': !canEditDetails, 'is-blocked': consentStatus === 0 }]"
                         :disabled="canEditDetails === false || consentStatus === 0"
                         data-lpignore="true"
                         id="new-user-surname"
                         v-validate="'required'"
                         name="Last name"
                         v-on:keyup="fieldChange"
                         v-model="user.personal.last_name"/>
                  <span class="form-field-error" v-if="this.errors.has('Last name')">{{ this.errors.first('Last name') }}</span>
                </div>
                <div class="form-element">
                  <label for="new-user-email" class="form-label color-2-63">Email address</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Email'), 'is-locked': !canEditDetails }]"
                         :disabled="canEditDetails === false"
                         data-lpignore="true"
                         id="new-user-email"
                         v-validate="'required|email'"
                         name="Email"
                         v-on:keyup="fieldChange"
                         v-model="user.personal.email"/>
                  <span class="form-field-error" v-if="this.errors.has('Email')">{{ this.errors.first('Email') }}</span>
                </div>
                <div class="form-element">
                  <label for="new-user-phone" class="form-label color-2-63">Phone number</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Phone number'), 'is-locked': !canEditDetails, 'is-blocked':  consentStatus === 0 }]"
                         :disabled="canEditDetails === false || consentStatus === 0"
                         data-lpignore="true"
                         id="new-user-phone"
                         name="Phone number"
                         v-on:keyup="fieldChange"
                         v-model="user.personal.phone"/>
                  <span class="form-field-error" v-if="this.errors.has('Phone number')">{{ this.errors.first('Phone number') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half">
                <div class="form-element">
                  <label for="new-user-company-role" class="form-label color-2-63">User type (role)</label>
                  <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked is-blocked"
                            :class="[{ 'is-locked': !canEditDetails }]"
                            disabled="disabled"
                            :searchable=true
                            v-on:keyup="fieldChange"
                            v-model="user.personal.role"
                            :options="getRolesForSelect"
                            v-validate="'required'"
                            data-vv-name="Company role"
                            id="new-user-company-role"/>
                  <span class="form-field-error" v-if="this.errors.has('Company role')">{{ this.errors.first('Company role') }}</span>
                </div>
                <div class="form-element" v-if="this.isStakeholder === true">
                  <label for="new-user-company-stakeholder_type" class="form-label color-2-63">Stakeholder type</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Stakeholder type'), 'is-locked': !canEditDetails, 'is-blocked': (getUserRole !== 'gm' && getUserRole !== 'ca') || consentStatus === 0 }]"
                         :disabled="canEditDetails === false || (getUserRole !== 'gm' && getUserRole !== 'ca') || consentStatus === 0"
                         data-lpignore="true"
                         v-on:keyup="fieldChange"
                         v-model="user.personal.stakeholder_type"
                         data-vv-name="Stakeholder type"
                         name="Stakeholder type"
                         id="new-user-company-stakeholder_type"/>
                </div>
                <div class="form-element" v-if="user.personal.role && user.personal.role.slug !== 'gm'">
                  <label for="new-user-company-name" class="form-label color-2-63">Company name</label>
                  <v-select class="form-control form-control__select background-1-10-child  border-1-10-child background-2-10-locked border-2-10-locked"
                            :class="[{ 'has-error': errors.has('Company'), 'is-locked': !canEditDetails, 'is-blocked': getUserRole !== 'gm' || consentStatus === 0 }]"
                            :disabled="canEditDetails === false || getUserRole !== 'gm' || consentStatus === 0"
                            :searchable="true"
                            v-on:keyup="fieldChange"
                            v-model="user.personal.company"
                            :options="getCompaniesForSelect"
                            v-validate="'required'"
                            data-vv-name="Company name"
                            id="new-user-company-name"/>
                  <span class="form-field-error" v-if="this.errors.has('Company name')">{{ this.errors.first('Company name') }}</span>
                </div>
                <div class="form-element">
                  <label for="new-user-company-function" class="form-label color-2-63">Function</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Function'), 'is-locked': !canEditDetails, 'is-blocked': (getUserRole !== 'gm' && getUserRole !== 'ca') || consentStatus === 0 }]"
                         :disabled="canEditDetails === false || (getUserRole !== 'gm' && getUserRole !== 'ca') || consentStatus === 0"
                         data-lpignore="true"
                         id="new-user-company-function"
                         name="Function"
                         v-on:keyup="fieldChange"
                         v-model="user.personal.function"/>
                  <span class="form-field-error" v-if="this.errors.has('Function')">{{ this.errors.first('Function') }}</span>
                </div>
                <div class="form-element">
                  <label for="new-user-company-title" class="form-label color-2-63">Job title</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                         :class="[{ 'has-error': errors.has('Job title'), 'is-locked': !canEditDetails, 'is-blocked': (getUserRole !== 'gm' && getUserRole !== 'ca') || consentStatus === 0 }]"
                         :disabled="canEditDetails === false || consentStatus === 0"
                         data-lpignore="true"
                         id="new-user-company-title"
                         name="Job title"
                         v-on:keyup="fieldChange"
                         v-model="user.personal.job_title"/>
                  <span class="form-field-error" v-if="this.errors.has('Job title')">{{ this.errors.first('Job title') }}</span>
                </div>
              </div>
              <div class="form-group form-group-half" v-if="getUserRole === 'gm'">
                <div class="form-element">
                  <label for="new-user-id" class="form-label color-2-63">User id</label>
                  <input type="text" class="form-control form-control__input background-1-10-disabled  border-1-10-disabled is-blocked"
                         :class="[{ 'is-locked': !canEditDetails }]"
                         disabled="disabled"
                         data-lpignore="true"
                         id="new-user-id"
                         v-validate="'required'"
                         v-model="user.personal.id"/>
                </div>
              </div>
            </section>
            <div class="clearfix"></div>
            <div class="update-data update-data__details" v-if="canEditDetails">
              <button v-on:click.prevent="closeEditDetails()" class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Discard changes</button>
              <button v-on:click.prevent="updateProfileDetails()" class="save-edit background-1-100 color-2-100 save-edit-details">Save changes</button>
            </div>
          </div>
          <div class="content-section profile-section"
               tabindex="-1"
               ref="userPassword"
               :class="[{ 'content-section__closed': canEditPassword === false, 'content-section__bordered border-1-20': activeSection === 'userPassword' || canEditPassword }]">
            <section class="password-info">
              <h3 class="content-section-title color-1-100 background-1-100-before">
                <template v-if="canEditPassword === false">My account password</template>
                <template v-else>Edit my account password</template>
              </h3>
              <button v-on:click.prevent="openEditPassword()"
                      class="edit-password edit-password-custom border-1-40 color-2-100" v-if="canEditPassword === false">
                <span class="edit-icon color-1-100">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 12.955 12.921" style="enable-background:new 0 0 12.955 12.921;" xml:space="preserve">
                    <g id="XMLID_1_">
                      <path id="XMLID_4_" class="st0" d="M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921
                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"/>
                      <path id="XMLID_5_" class="st0" d="M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316
                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0
                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"/>
                    </g>
                  </svg>
                </span>
                Edit
              </button>
              <form v-on:submit="updateProfilePassword()" class="form-group" v-show="canEditPassword" data-vv-scope="password">
                <div class="form-group form-group-half">
                  <div class="form-element">
                    <label for="current-password" class="form-label color-2-63">Current password</label>
                    <input class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           id="current-password"
                           :disabled="canEditPassword === false"
                           data-lpignore="true"
                           type="password"
                           name="current-password"
                           data-vv-name="Current password"
                           v-validate="'required'"
                           v-on:keyup="fieldChange"
                           v-model="user.personal.current_password">
                    <span class="form-field-error" v-if="this.errors.has('password.current-password')">{{ this.errors.first('password.current-password') }}</span>
                  </div>
                </div>
                <div class="clearfix"></div>
                <div class="form-group form-group-half">
                  <div class="form-element">
                    <label for="new-password" class="form-label color-2-63">New password</label>
                    <input class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           id="new-password"
                           ref="passwordInput"
                           :class="[{ 'has-error': passwordError }]"
                           :disabled="canEditPassword === false"
                           data-lpignore="true"
                           type="password"
                           name="new-password"
                           data-vv-name="New password"
                           v-validate="'required'"
                           v-on:keyup="fieldChange"
                           v-model="user.personal.plainPassword.first">
                    <span class="form-field-error" v-if="this.errors.has('password.new-password')">{{ this.errors.first('password.new-password') }}</span>
                  </div>
                </div>
                <div class="form-group form-group-half">
                  <div class="form-element">
                    <label for="retype-password" class="form-label color-2-63">Retype new password</label>
                    <input class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           id="retype-password"
                           :class="[{ 'has-error': passwordError }]"
                           :disabled="canEditPassword === false"
                           data-lpignore="true"
                           type="password"
                           name="retype-new-password"
                           data-vv-as="password"
                           data-vv-name="Retype new password"
                           v-validate="'required|confirmed:passwordInput'"
                           v-on:keyup="fieldChange"
                           v-model="user.personal.plainPassword.second">
                    <span class="form-field-error" v-if="this.errors.has('password.retype-new-password')">{{ this.errors.first('password.retype-new-password') }}</span>
                  </div>
                </div>
                <div class="password-helper-text color-2-63">
                  The new password can't be the same as the old password.<br/>
                  Please use a strong password. It must contain at least 9 characters that include capital letters, lower case letters and numbers.
                </div>
                <div class="update-data update-data__password" v-if="canEditPassword">
                  <button v-on:click.prevent="closeEditPassword()" class="cancel-edit background-2-7 color-2-100 cancel-edit-password">Discard changes</button>
                  <button v-on:click.prevent="updateProfilePassword()" class="save-edit background-1-100 color-2-100 save-edit-password">Save changes</button>
                </div>
              </form>
            </section>
            <div class="clearfix"></div>
          </div>
          <div class="content-section consent-section"
               v-show="!needPasswordChange"
               :class="[{ 'content-section__bordered border-1-20': activeSection === 'userData' }]"
               tabindex="-1"
               ref="userData">
            <section class="password-info">
              <h3 class="content-section-title color-1-100 background-1-100-before">My data</h3>
              <div class="consent-data" :class="this.consentStatus === 1 ? 'consent-given' : 'consent-not-given'">
                <template v-if="this.consentStatus === 1">
                  You provided us with consent to store and process your data under the GDPR settings on {{ this.convertDate(this.consentDate, '.') }}.
                </template>
                <template v-else>
                  <template v-if="this.consentDate">
                    You withdraw your consent to store and use your data under the GDPR settings on {{ this.convertDate(this.consentDate, '.') }}. <br/>
                    Please provide consent so you can use all the website functionalities.
                  </template>
                  <template v-else>
                    You haven’t provided yet us with consent to use your data, under the GDPR settings.<br/>
                    Please provide your consent so you can use all the website functionalities.
                  </template>
                </template>
              </div>
              <div class="clearfix"></div>
              <div class="update-data update-data__consent">
                <button
                   v-if="consentStatus === 1"
                   v-on:click.prevent="updateConsent(0)" class="update-consent not-consent consent background-1-20 color-2-100">Withdraw your consent</button>
                <router-link :to="{ name: 'privacy-policy' }"
                             :class="consentStatus === 1 ? 'not-consent background-1-100 color-2-100' : 'consent background-1-20 color-2-100'"
                             class="privacy-policy">View our privacy policy</router-link>
                <button
                   v-if="consentStatus === 0"
                   v-on:click.prevent="updateConsent(1)" class="update-consent consent background-1-100 color-2-100">Consent now</button>
              </div>
            </section>
          </div>
        </div>
      </div>
	  </div>
  </div>
  <!-- END:.profile -->
</template>

<script>
import api from '@/api'
import { mapActions, mapGetters } from 'vuex'
import AppSelect from '@/components/admin/common/Select'

export default {
  name: 'profile',
  data: function () {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      messageDisplay: false,
      canEditDetails: false,
      canEditPassword: false,
      passwordError: false,
      user: {
        personal: {
          id: '',
          name: '',
          first_name: '',
          last_name: '',
          email: '',
          company: null,
          role: null,
          phone: null,
          job_title: '',
          function: null,
          stakeholder_type: '',
          current_password: '',
          plainPassword: {
            first: '',
            second: ''
          },
          image: ''
        }
      },
      consentStatus: 0,
      consentDate: null,
      canLeave: false,
      next: null,
      initialData: {},
      isChanged: false,
      isStakeholder: false,
      activeSection: 'userDetails',
      needPasswordChange: false,
      isThumbnailFileUploaded: false
    }
  },
  computed: {
    ...mapGetters([
      'selectedHightCont',
      'getCompaniesForSelect',
      'getRolesForSelect',
      'BlueYelBlue',
      'blackYelBlack',
      'getUserRole',
      'getConfData'
    ]),
    veeValidateFileUploadRules () {
      return {
        required: false,
        mimes: 'image/*'
      }
    }
  },
  methods: {
    ...mapActions([
      'clearConfAction',
      'getRoles',
      'getCompanies',
      'setInformationMsg',
      'initConfAction',
      'authLogout',
      'changeConsent'
    ]),
    openEditPassword: function () {
      this.canEditPassword = true
    },
    openEditDetails: function () {
      this.canEditDetails = true
    },
    closeEditPassword: function () {
      this.user.personal.current_password = ''
      this.user.personal.plainPassword = {
        first: '',
        second: ''
      }
      this.canEditPassword = false
      this.messageDisplay = false
    },
    closeEditDetails: function () {
      this.user.personal = this.initialData
      this.canEditDetails = false
      if (this.errors) {
        let self = this
        setTimeout(function () {
          self.errors.clean()
        }, 100)
      }
      this.messageDisplay = false
    },
    closeMsg: function () {
      this.errors.clear()
      this.messageDisplay = false
    },
    deleteMyProfile () {
      this.initConfAction({
        actionName: 'removeProfile'
      })
    },
    deleteMyProfileConfirmed () {
      let id = this.user.personal.id
      this.$http.delete(api.URLS.user + '/' + id, api.headersAuthSettings)
          .then((res) => {
            console.log(res)
            this.authLogout()
          })
          .catch((err) => {
            console.log(err)
          })
      this.getConfData.actionConfirmed = false
    },
    fieldChange () {
      this.isChanged = true
    },
    getProfileData (dontResetInfoMsg = false) {
      let route = this.$route.name
      this.$http.put(api.URLS.profile, {}, api.headersAuthSettings).then((res) => {
        if (res.body.consent_status === 1 && res.body.role.slug === 'ca') {
          this.$store.commit('authLoginSetUserRole', 'ca')
        }
        if (res.body.consent_status === 0 && res.body.role.slug === 'ca') {
          this.$store.commit('authLoginSetUserRole', 'sh')
        }
        if (res.body.password_changed && route !== 'give-consent' && dontResetInfoMsg === false) {
          this.needPasswordChange = true
          this.openEditPassword()
          this.infMsgTitle = 'You must change your password'
          this.infMsgDescription = 'You just logged in with temporary credentials. It happens when you just activated your account or when your password was changed by an account administrator or by a Clear Assured support officer. You must set your own password before you can resume your session.'
          this.infMsgClass = 'warning'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
        }
        let personal = this.user.personal
        // set page user data
        personal.id = res.body.id
        personal.first_name = res.body.first_name
        personal.last_name = res.body.last_name
        personal.email = res.body.email
        personal.phone = res.body.phone
        personal.function = res.body.function
        personal.job_title = res.body.job_title
        if (res.body.image) {
          personal.image = (api.serverURL + '/uploads/images/users/' + res.body.image)
          this.isThumbnailFileUploaded = true
        }
        if (res.body.company) {
          personal.company = {
            id: res.body.company.id,
            label: res.body.company.name,
            value: res.body.company.id
          }
        }
        personal.role = {
          id: res.body.role.id,
          label: res.body.role.name,
          value: res.body.role.id,
          slug: res.body.role.slug
        }
        personal.stakeholder_type = res.body.stakeholder_type
        personal.plainPassword = {
          first: '',
          second: ''
        }
        // set consent data
        this.consentStatus = res.body.consent_status
        this.consentDate = res.body.consent_updated
        // set initial data
        this.initialData.id = personal.id
        this.initialData.first_name = personal.first_name
        this.initialData.last_name = personal.last_name
        this.initialData.email = personal.email
        this.initialData.phone = personal.phone
        this.initialData.function = personal.function
        this.initialData.job_title = personal.job_title
        this.initialData.company = personal.company ? personal.company : null
        this.initialData.role = personal.role
        this.initialData.stakeholder_type = personal.stakeholder_type
        this.initialData.plainPassword = personal.plainPassword
        this.initialData.image = personal.image
        this.checkSubscribe(this.initialData.email)

        document.title = personal.first_name + ' ' + personal.last_name + '\'s profile details | Clear Assured'
        this.$store.commit('setUserDimensions')
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname])
          window._paq.push(['setDocumentTitle', document.title])
          window._paq.push(['trackPageView'])
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'DASHBOARD_AREA')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      }).catch((err) => {
        if (err.status === 404) {
          let props = this.$router.resolve({
            name: 'error'
          })
          this.$router.push(props.href)
        }
        if (err.status === 401) {
          this.authLogout()
        }
      })
    },
    updateProfileDetails () {
      if (this.disableAPI) return
      this.$validator.validateAll()
      if (this.errors.items.length) return
      let userData = {
        firstName: this.user.personal.first_name,
        lastName: this.user.personal.last_name,
        email: this.user.personal.email,
        phone: this.user.personal.phone,
        image: this.user.personal.image
      }
      if (this.getUserRole === 'gm' || this.getUserRole === 'ca') {
        userData.function = this.user.personal.function
        userData.jobTitle = this.user.personal.job_title
        userData.company = this.user.personal.company
        userData.role = this.user.personal.role
        userData.stakeholderType = this.user.personal.stakeholder_type
      }
      this.disableAPI = true
      this.$http.put(api.URLS.profile, userData, api.headersAuthSettings)
        .then((res) => {
          this.disableAPI = false
          this.infMsgTitle = 'Your profile details was successfully updated.'
          this.infMsgDescription = 'Please note these actions are being logged.'
          this.infMsgClass = 'success'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
          this.getProfileData()
          this.canEditDetails = !this.canEditDetails
        })
        .catch((err) => {
          this.disableAPI = false
          console.log('err', err)
          this.infMsgTitle = 'Error. We were not able to update your profile '
          for (let error in err.body.error.exception) {
            this.infMsgTitle += err.body.error.exception[error].message + ' '
          }
          this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
          this.infMsgClass = 'error'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
          this.getProfileData()
        })
    },
    updateProfilePassword () {
      if (this.disableAPI) return
      this.$validator.validateAll('password')
      let firstPassword = this.user.personal.plainPassword.first
      let secondPassword = this.user.personal.plainPassword.second
      if (firstPassword !== secondPassword) {
        this.passwordError = true
        this.infMsgTitle = 'Passwords doesn\'t match!'
        this.infMsgDescription = 'New password and Retype new password fields doesn\'t match. Please recheck!'
        this.infMsgClass = 'error'
        this.setInformationMsg({
          isShown: true,
          title: this.infMsgTitle,
          text: this.infMsgDescription,
          className: this.infMsgClass
        })
        return
      }
      let userData = {
        currentPassword: this.user.personal.current_password,
        newPassword: firstPassword
      }
      this.disableAPI = true
      this.$http.put(api.URLS.profile, userData, api.headersAuthSettings)
        .then((res) => {
          this.disableAPI = false
          this.needPasswordChange = false
          let name = ''
          if (res.body.first_name) {
            name += res.body.first_name
          }
          if (res.body.first_name && res.body.last_name) {
            name += ' '
          }
          if (res.body.last_name) {
            name += res.body.last_name
          }
          if (name === '') {
            name = res.body.email
          }
          this.infMsgTitle = name + '\'s profile password was successfully updated.'
          this.infMsgDescription = 'Please note these actions are being logged.'
          this.infMsgClass = 'success'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
          this.passwordError = false
          this.canEditPassword = !this.canEditPassword
          this.getProfileData(true)
          this.messageDisplay = true
        })
        .catch((err) => {
          const exceptions = err.body && err.body.error && err.body.error.exception ? err.body.error.exception.map(e => e.message) : ['Something went wrong and the server can\'t figure out what. Please send us a message using the \'Send us your feedback\' button to the left. We will investigate and get back to you shortly.']
          this.getProfileData(true)
          this.disableAPI = false
          this.infMsgTitle = 'Password was not changed!'
          this.infMsgDescription = exceptions.join('. ')
          // for (let error in err.body.error.exception) {
          //   this.infMsgDescription += err.body.error.exception[error].message + ' '
          // }
          this.infMsgClass = 'error'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
          this.passwordError = false
          this.messageDisplay = true
        })
    },
    updateConsent (consent) {
      let body = {
        consent: consent
      }
      this.$http.put(api.URLS.updateConsent, body, api.headersAuthSettings).then(() => {
        if (consent === 1) {
          this.$store.commit('changeConsent', 'false')
          if (!this.user.personal.first_name || !this.user.personal.last_name || this.user.personal.first_name === '' || this.user.personal.last_name === '') {
            this.openEditDetails()
            this.infMsgTitle = 'Please complete your profile'
            this.infMsgDescription = 'Thank you for activating your account. Please fill in your profile data before you resume your session.'
            this.infMsgClass = 'warning'
            this.setInformationMsg({
              isShown: true,
              title: this.infMsgTitle,
              text: this.infMsgDescription,
              className: this.infMsgClass
            })
          }
          this.setInformationMsg({
            isShown: false,
            title: '',
            text: '',
            className: ''
          })
        } else {
          this.$store.commit('changeConsent', 'true')
          this.infMsgTitle = 'Some features may be unavailable'
          this.infMsgDescription = 'You have not provided us with consent to access and process your data. You may still use the website, yet some of the features will be unavailable. You may change your mind and provide consent at any time and all the features associated with your role will become available.'
          this.infMsgClass = 'error'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
        }
        this.getProfileData()
      }).catch((err) => {
        if (err.status === 401) {
          this.authLogout()
        }
      })
    },
    convertDate (payload, delimetr) {
      if (!payload) return
      let date = new Date(payload)
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      return toDoubleDigit(day) + delimetr + toDoubleDigit(month) + delimetr + fullYear
    },
    goToPageSection (ref) {
      let element = this.$refs[ref]
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
        setTimeout(function () {
          element.focus()
        })
      }
    },
    posY (elm) {
      let test = elm
      let top = 0
      while (test !== null && test.tagName.toLowerCase() !== 'body') {
        top += test.offsetTop
        test = test.offsetParent
      }
      return top
    },
    scrollY () {
      if (window.pageYOffset) {
        return window.pageYOffset
      }
      return Math.max(document.documentElement.scrollTop, document.body.scrollTop)
    },
    isScrolledIntoView (elem) {
      let docViewTop = this.scrollY()
      let docViewBottom = docViewTop + window.outerHeight
      let elemTop = this.posY(elem) + 300
      let elemBottom = elemTop + elem.offsetHeight
      return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop))
    },
    handleScroll () {
      let sections = this.$refs
      for (let index in sections) {
        let section = sections[index]
        if (section && this.isScrolledIntoView(section)) {
          this.activeSection = index
        }
      }
    },
    onThumbnailFileChange (e) {
      let self = this
      var input = document.getElementById('uploadThumbnail')
      if (input.files && input.files[0] && input.files[0].name.match(/.(jpg|jpeg|png|gif)$/i)) {
        this.isThumbnailFileUploaded = true
        var reader = new FileReader()
        reader.onload = function (e) {
          self.user.personal.image = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    removeThumbnail () {
      var input = document.getElementById('uploadThumbnail')
      input.value = null
      this.isThumbnailFileUploaded = false
      this.user.personal.image = false
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.user.personal.first_name !== this.initialData.first_name ||
      this.user.personal.last_name !== this.initialData.last_name ||
      this.user.personal.email !== this.initialData.email) {
      if (this.confirmation) {
        this.confirmation.isShown = true
      }
      this.next = next
    } else {
      next()
    }
  },
  components: {
    AppSelect
  },
  watch: {
    'getConfData.actionConfirmed' (value) {
      if (value) {
        this.deleteMyProfileConfirmed()
        this.clearConfAction()
      }
    },
    'user.personal.role' (value) {
      if (value && value !== this.initialData.role && this.getUserRole !== 'gm' && this.getUserRole !== 'ca') {
        alert('Good try, but this will not work!')
        this.user.personal.role = this.initialData.role
      }
      if (value && value.slug === 'sh') {
        this.isStakeholder = true
      } else {
        this.isStakeholder = false
      }
    },
    'user.personal.job_title' (value) {
      if (value && value !== this.initialData.job_title && this.getUserRole !== 'gm' && this.getUserRole !== 'ca') {
        alert('Good try, but this will not work!')
        this.user.personal.job_title = this.initialData.job_title
      }
    },
    'user.personal.company' (value) {
      if (value && value !== this.initialData.company && this.getUserRole !== 'gm' && this.getUserRole !== 'ca') {
        alert('Good try, but this will not work!')
        this.user.personal.company = this.initialData.company
      }
    },
    'user.personal.function' (value) {
      if (value && value !== this.initialData.function && this.getUserRole !== 'gm' && this.getUserRole !== 'ca') {
        alert('Good try, but this will not work!')
        this.user.personal.function = this.initialData.function
      }
    },
    'user.personal.stakeholder_type' (value) {
      if (value && value !== this.initialData.stakeholder_type && this.getUserRole !== 'gm' && this.getUserRole !== 'ca') {
        alert('Good try, but this will not work!')
        this.user.personal.stakeholder_type = this.initialData.stakeholder_type
      }
    }
  },
  beforeMount () {
    this.getRoles()
    this.getCompanies()
    document.title = 'Clear Assured – Your profile details'
  },
  mounted () {
    this.getProfileData()
  },
  created () {
    let query = this.$route.query
    if (query) {
      if (query.consent === '1') {
        this.openEditDetails()
        this.infMsgTitle = 'Please complete your profile'
        this.infMsgDescription = 'Thank you for activating your account. Please fill in your profile data before you resume your session.'
        this.infMsgClass = 'warning'
        this.setInformationMsg({
          isShown: true,
          title: this.infMsgTitle,
          text: this.infMsgDescription,
          className: this.infMsgClass
        })
      }
      if (query.consent === '0') {
        this.openEditDetails()
        this.infMsgTitle = 'Some features may be unavailable'
        this.infMsgDescription = 'You have not provided us with consent to access and process your data. You may still use the website, yet some of the features will be unavailable. You may change your mind and provide consent at any time and all the features associated with your role will become available.'
        this.infMsgClass = 'error'
        this.setInformationMsg({
          isShown: true,
          title: this.infMsgTitle,
          text: this.infMsgDescription,
          className: this.infMsgClass
        })
      }
    }
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style src='@/assets/scss/components/profile.scss' lang='scss' />



// WEBPACK FOOTER //
// Profile.vue?dcad7d98